import React from "react";

const Information = ({ label='', value, raw }) => (
  <div className="Product-Information">
    <div className="label" name={label}>{label.toLowerCase()}</div>
    { (!!raw) ? <div className="s">{value}</div>  :
      <div className="value" dangerouslySetInnerHTML={{__html: value}}/>
    }
  </div>
);

export default ({ values }) => (<div className='Product-Information-Wrapper'>{
  values.map((a,i) =>
  <Information key={i.toString()} label={a.name} value={a.value} raw={a.raw}/>)}
</div>);
